<template>
  <carousel
    :per-page="1"
    pagination-color="#B3BCCB"
    pagination-active-color="#000000"
    :pagination-padding="7"
    :pagination-size="5"
    :navigation-enabled="true"
    :navigation-click-target-size="5"
    navigation-next-label="<span class='iconfont-arrow-forward'></span>"
    navigation-prev-label="<span class='iconfont-arrow-back'></span>"
  >
    <slide>
      <h2 class="heading -large -light">
        “Fitness Blender helped me get my self confidence back. I look great, and I feel even
        better! I can't imagine my life without it.”
      </h2>
      <p class="no-pad">Debbie M.</p>
    </slide>
    <slide>
      <h2 class="heading -large -light">
        “I love the ease of working out at home & you two are the most down to earth,
        non-intimidating fitness instructors out there.”
      </h2>
      <p class="no-pad">Erin G.</p>
    </slide>
    <slide>
      <h2 class="heading -large -light">
        “FINALLY an affordable product that delivers EXACTLY what it says it will! I'm totally blown
        away. I’m totally hooked.”
      </h2>
      <p class="no-pad">Danielle B.</p>
    </slide>
  </carousel>
</template>

<script>
// @flow
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'HomeCarousel',
  components: {
    Carousel,
    Slide,
  },
  props: {},
}
</script>
